import { DetalleServicioPropiedadNoProcesadoDto } from "./detalleServicioPropiedadNoProcesadoDto.model"

export class UploadFileResponse{
  public idsDetalleServiciosPropiedadGenerados: number[] = []
  public detalleServicioPropiedadNoProcesados: DetalleServicioPropiedadNoProcesadoDto[]= []
}
